<script>
  import ProtectedImage from "@components/ProtectedImage.svelte"

  export let product

  /** @type {boolean} */
  export let hovering = false
</script>

<ProtectedImage
  aspect="square"
  src={product.featured_image_url}
  alt={product.name}
  width={600}
  quality={60}
  class=" c-product-card__image c-product-card__image--featured w-full"
/>

{#if product.hover_image_url && hovering}
  <div class="[ absolute inset-0 ]">
    <ProtectedImage
      aspect="square"
      src={product.hover_image_url}
      alt={product.name}
      width={600}
      quality={60}
      class=" c-product-card__image c-product-card__image--hover w-full"
    />
  </div>
{/if}
